<template>
  <div class="delete-mask" @click.stop="cancel">
    <div class="delete-container">
      <div class="btn-item danger" @click.stop="delComment">删除评论</div>
      <div class="btn-item info" @click.stop="comment">回复</div>
      <div class="btn-item" @click.stop="cancel">取消</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {}
  },
  methods: {
    delComment() {
      this.$emit('delete')
    },
    comment() {
      this.$emit('reply')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.delete-mask {
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 999;
}
.info {
  color: #5791e9;
}
.delete-container {
  text-align: center;
  border-radius: 2.7vw;
  padding: 4vw 2.7vw;
  box-sizing: border-box;
  width: 95%;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 8vw;
  background-color: #f9f9f9;
}
.danger {
  color: #dd3535;
}
.btn-item {
  line-height: 13.3vw;
  height: 13.3vw;
  border-bottom: 1px solid #f1f1f1;
}
.delete-container .btn-item:last-child {
  border-bottom: none;
}
</style>
